<template>
    <div class="main">
        <c-panel title="ÁREA E CAPACIDADE DAS DEPENDÊNCIAS" titleIcon="fas fa-ruler-combined">

            <el-alert type="info" :closable="false" class="u-mb-15"
                :title="'A capacidade é calculada pelo servidor: área ÷ m² por aluno. Deixando os m² por aluno em branco, vale o padrão da rede (' + padrao + ' m²).'"></el-alert>

            <el-alert v-if="aviso" type="warning" :closable="false" class="u-mb-15" :title="aviso"></el-alert>

            <el-form label-position="top" @submit.native.prevent>
                <el-row :gutter="10" class="u-mb-15">
                    <el-col :xs="24" :sm="8">
                        <el-form-item label="Escola" class="u-mb-0">
                            <el-select v-model="instituicaoId" filterable style="width: 100%;" @change="carregar">
                                <el-option v-for="i in instituicoes" :key="i.id" :value="i.id" :label="i.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6">
                        <el-form-item label="Período letivo" class="u-mb-0">
                            <el-select v-model="periodoId" style="width: 100%;" @change="carregar">
                                <el-option v-for="p in periodos" :key="p.id" :value="p.id" :label="p.nome"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="10">
                        <div v-if="totais" class="u-text-right u-mt-25">
                            <span class="resumo">{{ totais.com_area }} de {{ totais.dependencias }} com área informada</span>
                            <span class="resumo destaque">capacidade total: {{ totais.capacidade_total }} aluno(s)</span>
                        </div>
                    </el-col>
                </el-row>
            </el-form>

            <div v-if="carregando" class="u-text-center u-mt-25"><img src="/public/img/loading-bar.gif" /></div>

            <el-alert v-else-if="erro" :title="erro" type="warning" :closable="false"></el-alert>

            <div v-else-if="linhas.length" class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>Dependência (tipo declarado no Censo)</th>
                            <th style="width: 110px;">Quantidade</th>
                            <th style="width: 130px;">Área (m²)</th>
                            <th style="width: 150px;">m² por aluno</th>
                            <th style="width: 140px;" class="u-text-center">Capacidade</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(l, idx) in linhas" :key="idx">
                            <td>{{ l.nome }}</td>
                            <td><el-input v-model="l.quantidade" v-mask="'###'" size="mini" placeholder="—"></el-input></td>
                            <td><el-input v-model="l.area_m2" size="mini" placeholder="Ex.: 48,00"></el-input></td>
                            <td>
                                <el-input v-model="l.alunos_por_m2" size="mini" :placeholder="'padrão: ' + padrao"></el-input>
                            </td>
                            <td class="u-text-center">
                                <span :class="capacidade(l) === null ? 'sem-dado' : 'com-dado'">
                                    {{ capacidade(l) === null ? '—' : capacidade(l) }}
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <el-alert v-else type="info" :closable="false"
                title="Esta escola não tem dependências declaradas na infraestrutura do Censo."></el-alert>

            <div class="u-text-right u-mt-20" v-if="podeEscrever && linhas.length">
                <el-button type="primary" @click="salvar">SALVAR ÁREAS</el-button>
            </div>
        </c-panel>
    </div>
</template>
<script>
/**
 * BLOCO D — item 10 do edital (Timbé do Sul/SC): alunos por m².
 *
 * A capacidade exibida enquanto o usuário digita é uma PRÉVIA visual; quem calcula e grava
 * é o backend, com a mesma fórmula. A tela nunca persiste um número que ela própria tenha
 * inventado.
 *
 * As dependências listadas são apenas as que a escola declarou no Censo — não é possível
 * informar área de um tipo que a escola não possui.
 */
import { periodosLetivosMixin } from '@/shared/periodos-letivos'
export default {
    mixins: [periodosLetivosMixin],
    data: () => ({
        carregando: false, erro: '', aviso: null,
        instituicaoId: null, periodoId: null,
        instituicoes: [],
        linhas: [], totais: null, padrao: 1.20
    }),
    computed: {
        podeEscrever () { return [0, 1, 3, 4, 5, 6, 7, 9, 12].includes(parseInt(this.$store.state.user.tipo)) }
    },
    mounted () {
        this.periodoId = this.$store.state.config.periodo ? this.$store.state.config.periodo.id : null

        this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/capacidade-dependencia/initForm`,
            this.$store.getters.getHeaderAuth
        ).then(r => { if (r.data && r.data.alunos_por_m2_padrao) this.padrao = r.data.alunos_por_m2_padrao }).catch(() => {})

        const inst = this.$store.state.config.instituicao
        if (inst && inst.id) { this.instituicoes = [inst]; this.instituicaoId = inst.id; this.carregar() }
        else {
            this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAll`,
                this.$store.getters.getHeaderAuth
            ).then(r => { this.instituicoes = Array.isArray(r.data) ? r.data : [] }).catch(() => {})
        }
    },
    methods: {
        carregar () {
            if (!this.instituicaoId) return
            this.carregando = true
            this.erro = ''
            this.aviso = null
            this.linhas = []
            this.totais = null

            const base = `${this.$store.state.config.baseUrlApi}/api/capacidade-dependencia/getPorInstituicao/${this.instituicaoId}`

            this.$axios.get(base + (this.periodoId ? '/' + this.periodoId : ''),
                this.$store.getters.getHeaderAuth
            ).then(r => {
                this.carregando = false
                if (r.data && r.data.erro) { this.erro = this.textoErro(r.data.erro); return }
                this.linhas = (r.data.itens || []).map(i => Object.assign({}, i))
                this.totais = r.data.totais
                this.aviso = r.data.aviso
                if (r.data.alunos_por_m2_padrao) this.padrao = r.data.alunos_por_m2_padrao
            }).catch(e => { this.carregando = false; this.$store.commit('throwException', e) })
        },
        /** Prévia visual — o valor gravado é o que o backend calcula. */
        capacidade (l) {
            const area = this.numero(l.area_m2)
            if (area === null || area <= 0) return null

            const densidade = this.numero(l.alunos_por_m2) || Number(this.padrao)
            if (!densidade || densidade <= 0) return null

            return Math.floor(area / densidade)
        },
        numero (v) {
            if (v === null || v === undefined || v === '') return null
            const n = parseFloat(String(v).replace(',', '.'))
            return isNaN(n) ? null : n
        },
        salvar () {
            window.eventBus.$emit('loading', true)
            this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/capacidade-dependencia/salvarLote`,
                { instituicao_id: this.instituicaoId, periodo_letivo_id: this.periodoId, itens: this.linhas },
                this.$store.getters.getHeaderAuth
            ).then(r => {
                window.eventBus.$emit('loading', false)
                if (r.data && r.data.erro) { window.eventBus.$emit('alert', { msg: this.textoErro(r.data.erro), type: 'warning' }); return }
                window.eventBus.$emit('alert', { msg: r.data.mensagem + ' Capacidade total: ' + r.data.capacidade_total + '.', type: 'success' })
                this.carregar()
            }).catch(e => { window.eventBus.$emit('loading', false); this.$store.commit('throwException', e) })
        },
        textoErro (e) { return typeof e === 'string' ? e : (e.text || 'Não foi possível concluir.') }
    }
}
</script>
<style scoped>
.resumo { display: inline-block; margin-left: 14px; font-size: 12px; color: #666; }
.resumo.destaque { font-weight: bold; color: #2e7d32; }
.sem-dado { color: #999; }
.com-dado { font-weight: bold; color: #2e7d32; }
</style>
